import React from 'react'
import ResponsesBox from './PrevResponses'
import Wrapper from './styles'

const LogInForm = props => {
  return (
    <Wrapper>
      <ResponsesBox {...props} />
    </Wrapper>
  )
}

export default LogInForm
